import * as React from 'react';
import { SVGProps } from 'react';

const TableDelete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    {...props}
  >
    <path
      d="M1.625 3.25H2.70833H11.375"
      stroke="#4D648B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.33301 3.25004V2.16671C4.33301 1.87939 4.44714 1.60384 4.65031 1.40067C4.85347 1.19751 5.12902 1.08337 5.41634 1.08337H7.58301C7.87033 1.08337 8.14588 1.19751 8.34904 1.40067C8.5522 1.60384 8.66634 1.87939 8.66634 2.16671V3.25004M10.2913 3.25004V10.8334C10.2913 11.1207 10.1772 11.3962 9.97404 11.5994C9.77088 11.8026 9.49533 11.9167 9.20801 11.9167H3.79134C3.50402 11.9167 3.22847 11.8026 3.02531 11.5994C2.82214 11.3962 2.70801 11.1207 2.70801 10.8334V3.25004H10.2913Z"
      stroke="#4D648B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.41699 5.95837V9.20837"
      stroke="#4D648B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.58301 5.95837V9.20837"
      stroke="#4D648B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default TableDelete;
